import { FileEntity } from 'src/app/core';

export function getMainFileOrError(files: FileEntity[]): FileEntity {
  const filterResult = files.filter((file) => file.fieldname === 'main');

  if (filterResult.length > 0) {
    return filterResult[0];
  } else {
    throw new Error('Problem in finding main file of order');
  }
}

export function getMainFileOrNothing(
  files: FileEntity[]
): FileEntity | undefined {
  try {
    return getMainFileOrError(files);
  } catch (e) {
    return undefined;
  }
}
